// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bloc-page {
  min-height: 800px;
}

.titre {
  font-family: var(--font-bnp);
  margin-bottom: var(--spacer4);
  font-size: 2rem;
}
.titre h2 {
  text-transform: uppercase;
  margin: 0;
  font-weight: 600;
  font-size: 1em;
}
.titre .location {
  font-size: 0.7em;
  font-weight: 200;
}

.map {
  padding-bottom: 32px;
}

.map, .map img, .map #mapo {
  width: 100%;
  height: 385px;
}
@media screen and (max-width: 768px) {
  .map, .map img, .map #mapo {
    height: 50vh;
  }
}

.visite-disable {
  background: #8f9d98 !important;
  border: 1px solid #8f9d98;
  cursor: default;
}

.bloc-right {
  padding: 30px 30px 30px 30px;
}

.hero-edit .menu {
  position: absolute;
  top: 25px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px;
}

.hero-edit .menu i {
  color: white;
  cursor: pointer;
  font-size: 20px;
}

.hero-edit {
  position: relative;
  display: inline-block;
}

.hero {
  padding: 25px 0px 0px 25px;
  position: relative;
  display: inline-block;
}

.hero img {
  object-fit: cover;
  display: block;
}

.hero img.loaded {
  display: block;
}

.divholder {
  background-color: #FFF;
  width: 100%;
  height: 100%;
}

.invert i {
  color: #FFF !important;
}

.bloc-focus i {
  color: var(--primary);
  font-size: 1.5rem;
}

.bloc-focus {
  cursor: pointer;
}

.notif-taille {
  text-align: center;
  color: #a10a0a;
  font-size: 10pt;
}

.upload-container {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  margin: 20px 0;
  height: 120px;
  padding-top: 10px !important;
}

.upload-container-input {
  border: 2px dashed #ccc;
  text-align: center;
  margin: 20px 0;
  height: 120px;
}

.upload-container-input:focus-within {
  border: 2px dashed #838181;
}

.textarea {
  width: 100%;
  height: 100%;
  border: none;
  resize: none;
  padding-left: 5px;
}

.textarea:focus-visible {
  outline: none;
}

.preview-img {
  margin-top: 0px;
  height: 160px !important;
}

.bloc-urls {
  padding: 25px 0px 0px 40px;
  height: 150px;
}

.url-visits {
  margin-left: 30px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
